/**
 * Stats band: the tile pattern scrolls at 30% of page speed (parallax).
 * The page scrolls inside .page-wrapper, not the window, so the listener is
 * captured at the document. Does nothing for visitors who prefer reduced motion.
 */
(function () {
  const band = document.querySelector('[data-cs-pattern]');
  const base = band && band.querySelector('[data-cs-pattern-base]');
  if (!base || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const TW = 330.4, TH = 638.7, SPEED = 0.3;
  let raf = 0;

  function update() {
    raf = 0;
    const r = band.getBoundingClientRect();
    const dy = (r.top - window.innerHeight / 2) * -SPEED;
    base.style.backgroundPosition = `0 ${dy}px, ${TW / 2}px ${TH / 2 + dy}px`;
  }
  document.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(update); }, { passive: true, capture: true });
  update();
})();
